import { ChangeDetectionStrategy, Component, input } from '@angular/core';

@Component({
  selector: 'app-client-on-stop-warning',
  templateUrl: './client-on-stop-warning.component.html',
  styleUrl: './client-on-stop-warning.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ClientOnStopWarningComponent {
  show = input(false);
  tooltipText = input<string | null>(null);
  label = input('Account placed on stop');
}
